var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-message-header",class:{
    'c-message-header--success': _vm.success,
    'c-message-header--error': _vm.error
  }},[_c('div',{staticClass:"c-message-header__icon"},[_c('o-icon',{attrs:{"icon":_vm.icon,"size":"large"}})],1),_c('h2',{staticClass:"c-message-header__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }